var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-down page"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.$t('server_down.title')))]),_c('p',{staticClass:"has-text-centered"},[_vm._v(" "+_vm._s(_vm.$t('server_down.text'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }